import { getDeviceConnectionDate } from 'helpers/auth/devices';
import { Format, formatDate } from 'helpers/date';

import { Device } from './types';

export {
  compareConnectionDate,
  getDeviceConnectionDate,
  getDeviceLocation,
  isDeviceBlocked,
  isDeviceTrusted,
} from 'helpers/auth/devices';

export const getDeviceLastActivityFormattedDate = (
  device: Device,
  format: Format,
) => {
  const connectionDate = getDeviceConnectionDate(device);

  if (!connectionDate) {
    return '';
  }

  const formattedDate = formatDate(connectionDate, format);

  return formattedDate;
};
